import React from 'react';
import { Post } from '../../../../../../models/blog';
import styled from 'styled-components';
import he from 'he';
import { device } from '../../../../../../utils/use-device-type';
interface PostProps {
  post: Post;
  isEven: boolean;
}
interface PostImageProps {
  isEven: boolean;
}

const BlogPost: React.FC<PostProps> = ({ post, isEven }) => {
  const decodedTitle = he.decode(post.title.rendered);
  const readMore = he.decode('Read more');
  const imageUrl = post?.yoast_head_json?.og_image?.[0]?.url
    ? String(post.yoast_head_json.og_image[0].url)
    : '';
  const [src, setSrc] = React.useState<string>(imageUrl);
  const handleImgError = React.useCallback(() => {
    setSrc('');
  }, []);

  return (
    <PostContainer className={isEven ? 'reverse' : ''}>
      <Box>
        {src ? (
          <PostImage
            isEven={isEven}
            src={src}
            alt={decodedTitle}
            loading='lazy'
            decoding='async'
            onError={handleImgError}
          />
        ) : (
          <ImageFallback role='img' aria-label={decodedTitle} />
        )}
      </Box>
      <BoxText>
        <PostTitle>{decodedTitle}</PostTitle>
        <PostLink
          href={post.link}
          target='_blank'
          id='blog-post'
          rel='noopener noreferrer'
        >
          {readMore}
        </PostLink>
      </BoxText>
    </PostContainer>
  );
};

export default BlogPost;
const PostContainer = styled.div`
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  width: 100%;
  max-width: 253px;
  border-radius: 15px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  @media (min-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 290px;
    height: 254px;
  }
  @media (min-width: 1024px) {
    max-width: 353px;
    height: 320px;
  }
`;

const PostTitle = styled.h1`
  font-family: 'League Spartan', sans-serif !important;
  color: #283288;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  max-height: 60px;
  margin: 0 !important;
  @media ${device.splitScreen} {
    font-size: 18px;
    max-height: 60px;
  }

  @media ${device.laptop} {
    font-size: 18px;
    max-height: 60px;
    /* width: 65%;
    -webkit-line-clamp: 1; */
  }
`;

const PostLink = styled.a`
  text-decoration: none;
  color: #05c793 !important;
  margin: 10px;
  text-align: end;
  font-family: 'League Spartan', sans-serif !important;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  text-decoration-line: underline;

  @media ${device.laptop} {
    text-align: end;
  }
`;

const Box = styled.div`
  width: 100%;
  padding: 13px 10px 0 10px;
  @media ${device.splitScreen} {
    height: 180px;
    width: 340px;
    padding: 23px 20px 0 20px;
  }
  @media ${device.laptop} {
    width: 100%;
    height: auto;
  }
`;

const sharedMediaSizes = `
  height: 135px;
  width: 224px;
  border-radius: 15px;
  @media ${device.splitScreen} {
    height: 156px;
    width: 258px;
  }
  @media ${device.laptop} {
    height: 189px;
    width: 319px;
  }
`;

const PostImage = styled.img<PostImageProps>`
  ${sharedMediaSizes}
  object-fit: cover;
`;

const ImageFallback = styled.div`
  ${sharedMediaSizes}
  background: linear-gradient(90deg, #eef1f6 25%, #e3e7ef 37%, #eef1f6 63%);
  animation: shimmer 1.2s infinite;
  @keyframes shimmer {
    0% {
      background-position: -200px 0;
    }
    100% {
      background-position: calc(200px + 100%) 0;
    }
  }
`;

const BoxText = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  justify-content: space-between;

  @media ${device.laptop} {
    height: 100%;
    flex-direction: column;
    padding: 20px 20px 0 20px;
    justify-content: space-between;
  }
`;
